// extracted by mini-css-extract-plugin
module.exports = {"button-group":"button-group__wxarh","button-group__item":"button-group__item__bfIjy"};